module.exports = __webpack_public_path__ + "img/check.eff0ad60.svg";